// >>>>>>>>>>>>>>>>>>>>>>> Code to add >>>>>>>>
import React from "react";
import {
  LineChart as RechartsLineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ReferenceLine,
} from "recharts";
import "./ChangePercLine.css";

/** YYYY-MM-DD for tooltip label */
const formatISODate = (dateStr) => {
  if (typeof dateStr === "string" && /^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
    return dateStr.slice(0, 10);
  }
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return String(dateStr);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const ChangePercLine = ({ chartData, stockInfo, selectedPeriod }) => {
  if (!chartData || chartData.length === 0) {
    return <p>Loading chart data...</p>;
  }

  // Month vs Year x-axis logic (parity with VWAP/Volume)
  const showYears = ["3Y", "5Y", "MAX"].includes(selectedPeriod);
  const xTicks = showYears
    ? Array.from(new Set(chartData.map((d) => new Date(d.date).getFullYear())))
        .map((year) => chartData.find((d) => new Date(d.date).getFullYear() === year)?.date)
        .filter(Boolean)
    : undefined;

  // Segment renderer with green/red per segment
  const renderSegment = (props) => {
    const { points } = props;
    const [start, end] = points;
    const strokeColor = start?.payload?.changePercent >= 0 ? "#22c55e" : "#ef4444";
    return (
      <path
        d={`M${start.x},${start.y}L${end.x},${end.y}`}
        stroke={strokeColor}
        strokeWidth={2}
        fill="none"
      />
    );
  };

  return (
    <div className="chart-content">
      <h3>
        Daily Change % – {stockInfo.name} ({stockInfo.ticker})
      </h3>
      <div className="change-perc-chart-container">
        <ResponsiveContainer width="100%" height="100%">
          <RechartsLineChart
            data={chartData}
            margin={{ top: 10, right: 10, left: 10, bottom: 30 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 12, angle: -35, textAnchor: "end" }}
              interval="preserveStartEnd"
              ticks={xTicks}
              tickFormatter={(value) => {
                const d = new Date(value);
                return showYears
                  ? d.getFullYear().toString()
                  : d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
              }}
            />
            <YAxis
              tickFormatter={(v) => `${v.toFixed(2)}%`}
              tick={{ fontSize: 12 }}
              width={60}
            />
            <Tooltip
              formatter={(v) => [`${v.toFixed(2)}%`, "Change"]}
              labelFormatter={(label) => `Date: ${formatISODate(label)}`}
            />
            <ReferenceLine y={0} stroke="#666" strokeDasharray="3 3" />

            <Line
              type="monotone"
              dataKey="changePercent"
              dot={false}
              isAnimationActive={false}
              segment={renderSegment}
            />
          </RechartsLineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ChangePercLine;
// <<<<<<<<<<<<<<<<<<<<<<<< Code to add <<<<<<<<<<


// // src/charts/ChangePercLine.js
// import React from "react";
// import {
//   LineChart as RechartsLineChart,
//   Line,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer,
//   CartesianGrid,
//   ReferenceLine,
// } from "recharts";
// import "./ChangePercLine.css";

// const ChangePercLine = ({ chartData, stockInfo }) => {
//   if (!chartData || chartData.length === 0) {
//     return <p>No data to display.</p>;
//   }

//   // 1) just format the dates
//   const data = chartData.map((d) => ({
//     ...d,
//     formattedDate: new Date(d.date).toLocaleDateString("en-US", {
//       month: "short",
//       day: "numeric",
//     }),
//   }));

//   // 2) segment renderer that draws each pair of points
//   const renderSegment = (props) => {
//     const { points } = props;
//     const [start, end] = points;
//     const strokeColor =
//       start.payload.changePercent >= 0 ? "#22c55e" : "#ef4444";

//     return (
//       <path
//         d={`M${start.x},${start.y}L${end.x},${end.y}`}
//         stroke={strokeColor}
//         strokeWidth={2}
//         fill="none"
//       />
//     );
//   };

//   return (
//     <div className="chart-content">
//       <h3>
//         Daily Change % – {stockInfo.name} ({stockInfo.ticker})
//       </h3>
//       <ResponsiveContainer width="100%" height={300}>
//         <RechartsLineChart
//           data={data}
//           margin={{ top: 10, right: 10, left: 20, bottom: 30 }}
//         >
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis
//             dataKey="formattedDate"
//             tick={{ fontSize: 12 , angle: -35, textAnchor: 'end'}}
//             interval="preserveStartEnd"
//           />
//           <YAxis
//             tickFormatter={(v) => `${v.toFixed(2)}%`}
//             tick={{ fontSize: 12 }}
//             width={60}
//           />
//           <Tooltip
//             formatter={(v) => [`${v.toFixed(2)}%`, "Change"]}
//             labelFormatter={(label) => `Date: ${label}`}
//           />
//           <ReferenceLine y={0} stroke="#666" strokeDasharray="3 3" />

//           <Line
//             type="monotone"
//             dataKey="changePercent"
//             dot={false}
//             isAnimationActive={false}
//             segment={renderSegment}
//           />
//         </RechartsLineChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// export default ChangePercLine;
